import { render, staticRenderFns } from "./startpage.vue?vue&type=template&id=e28eb64e"
import script from "./startpage.vue?vue&type=script&lang=js"
export * from "./startpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports